<template>
  <div>
    <Redpack
      v-if="config.property_data.ids && !isEditorStatus"
      :bg="config.property_data.icon_url || bg"
      :ids="config.property_data.ids"
      :show_fix="config.property_data.show_fix"
      @checkPack="checkPack"
    ></Redpack>
    <div
      :class="config.property_data.show_fix == 2 ? 'edit-fix-img' : 'edit-img'"
      v-if="isEditorStatus"
    >
      <img :src="config.property_data.icon_url || bg" alt="" />
    </div>
  </div>
</template>


<script>
import Redpack from "@/plugin/cms/Redpack";

export default {
  name: "tms-biz-red-packet",
  props: ["config", "isEditorStatus"],
  data() {
    return {
      bg: "https://mktv-in-cdn.mockuai.com/16207160329923015.png?x-oss-process=image/resize,w_375/quality,Q_90",
      showPacket: true,
    };
  },
  components: {
    Redpack,
  },
  mounted() {},
  methods: {
    checkPack(status) {
      this.showPacket = status;
    },
  },
};
</script>
<style  lang="scss" scoped>
@import "./index.scss";
</style>